/**
 * Entry point pour la build SPA pure (LWS et autres hébergements statiques).
 * N'est pas utilisé par Lovable / Cloudflare (qui passent par TanStack Start).
 *
 * IMPORTANT : on monte RouterProvider INCONDITIONNELLEMENT.
 * La protection des routes se fait via <Guard> sur les pages protégées,
 * et la page /login est libre d'accès. Mettre une "AuthGate" autour du
 * RouterProvider provoque des re-mounts qui peuvent figer la page de login.
 */
import "../styles.css";
// Polices locales (remplace Google Fonts — évite les erreurs réseau / blocages)
import "@fontsource/inter-tight/400.css";
import "@fontsource/inter-tight/500.css";
import "@fontsource/inter-tight/600.css";
import "@fontsource/inter-tight/700.css";
import "@fontsource/fraunces/500.css";
import "@fontsource/fraunces/600.css";
import "@fontsource/fraunces/700.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { routeTree } from "../routeTree.gen";

const router = createRouter({
  routeTree,
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

function App() {
  // IMPORTANT : ne PAS wrapper ici avec AuthProvider/QueryClientProvider.
  // Ces providers sont déjà fournis par RootComponent dans src/routes/__root.tsx
  // (qui est rendu par RouterProvider en tant que root du routeTree).
  // Les dupliquer crée deux instances qui font chacune leur propre fetch
  // /api/auth/me et provoquent des boucles de re-render lors de la saisie.
  return (
    <RouterProvider router={router} />
  );
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
